import { render, staticRenderFns } from "./pedestrian-chart.vue?vue&type=template&id=0dedea00&scoped=true"
import script from "./pedestrian-chart.vue?vue&type=script&lang=js"
export * from "./pedestrian-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedea00",
  null
  
)

export default component.exports